import { motion } from "framer-motion";
import { CheckCircle, Users, ArrowRight } from "@phosphor-icons/react";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { IMAGES, fadeUp, WHATSAPP_JOB_URL } from "@/data/site";

const benefits = [
  "Ambiente profissional e colaborativo",
  "Oportunidades reais de crescimento",
  "Benefícios competitivos",
  "Equipamentos modernos"
];

const WorkWithUs = ({ showHeading = true }) => {
  return (
    <AnimatedSection id="trabalhe-conosco" className="section-padding bg-[#F5F5F5]">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div variants={fadeUp} className="order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img
                src={IMAGES.team}
                alt="Equipe Finegraf"
                className="w-full h-auto object-cover"
                data-testid="team-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#234D89]/80 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white font-semibold text-lg">
                  Faça parte do nosso time!
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="order-1 lg:order-2">
            {showHeading && (
              <>
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
                  Venha Crescer Conosco
                </span>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#234D89] mb-4">
                  Quer crescer no mercado gráfico?
                </h2>
                <div className="section-divider mb-6" />
              </>
            )}
            <p className="text-[#5C5C5C] mb-6 text-lg leading-relaxed">
              Estamos sempre em busca de <strong className="text-[#234D89]">profissionais talentosos</strong> e comprometidos. Se você tem experiência na área gráfica e busca um ambiente de trabalho profissional, queremos conhecer você!
            </p>

            <ul className="space-y-4 mb-8">
              {benefits.map((benefit) => (
                <li key={benefit} className="flex items-center gap-4 text-[#2B2B2B]">
                  <div className="w-10 h-10 bg-[#E73336]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <CheckCircle size={22} weight="fill" className="text-[#E73336]" />
                  </div>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            <motion.a
              href={WHATSAPP_JOB_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="work-whatsapp-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#234D89] text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#17325A] transition-all shadow-lg"
            >
              <Users size={22} weight="bold" />
              Quero me Candidatar
              <ArrowRight size={18} />
            </motion.a>
          </motion.div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default WorkWithUs;
